import { styles } from 'helpers'
import { PieChart, Pie, Cell, ResponsiveContainer, Label } from 'recharts'

const ProgressCircle = ({
  children,
  theme = 'dark',
  percentage,
  size = 'medium',
}) => {
  const data = [
    { name: '', value: percentage, color: styles.colors.secondary },
    { name: '', value: 100 - percentage, color: 'rgba(0,0,0,0.05)' },
  ]

  const color = theme === 'light' && 'white'
  const fontSize = size === 'medium' ? 24 : 16
  return (
    <ResponsiveContainer height="100%" width="100%">
      <PieChart>
        <Pie
          startAngle={90}
          endAngle={450}
          innerRadius="70%"
          data={data}
          strokeWidth={0}
          dataKey="value"
        >
          {data?.map((group, index) => (
            <Cell key={index} fill={group.color} />
          ))}
          <Label
            width={30}
            position="center"
            content={
              <CustomLabel
                percentage={percentage}
                label={children}
                fontSize={fontSize}
                color={color}
              />
            }
          />
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
}

function CustomLabel({ viewBox, percentage, label, color, fontSize }) {
  const { cx, cy } = viewBox
  return (
    <text
      x={cx}
      y={cy}
      fill={color ? color : styles.colors.primary}
      textAnchor="middle"
      dominantBaseline="central"
    >
      <tspan
        x={cx}
        alignmentBaseline="middle"
        fontSize={fontSize}
        dy={fontSize < 24 ? '-5' : '-10'}
      >
        {percentage}%
      </tspan>
      <tspan
        x={cx}
        fontSize={fontSize / 2}
        dy={fontSize < 24 ? fontSize / 1.5 : fontSize}
      >
        {label}
      </tspan>
    </text>
  )
}

export default ProgressCircle
